(function () {
  if (window.__limechatInitialized) return;
  window.__limechatInitialized = true;

  var STORAGE_KEY = 'limechat_session';
  var COOKIE_NAME = 'limechat_session';
  var CW_COOKIE = 'cw_conversation';
  var DEFAULT_TTL_MS = 12 * 60 * 60 * 1000;

  function getConfig() {
    var el = document.getElementById('limechat-widget-config');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, ttlMs) {
    var expires = new Date(Date.now() + ttlMs).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function generateId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'lc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}

    var cookieRaw = readCookie(COOKIE_NAME);
    if (!cookieRaw) return null;

    try {
      return JSON.parse(cookieRaw);
    } catch (e) {
      return null;
    }
  }

  function writeStore(data, ttlMs) {
    var payload = JSON.stringify(data);

    try {
      window.localStorage.setItem(STORAGE_KEY, payload);
    } catch (e) {}

    writeCookie(COOKIE_NAME, payload, ttlMs);
  }

  function getSession(ttlMs) {
    var stored = readStore();
    if (!stored || typeof stored !== 'object') {
      return { sessionId: null, visitorId: generateId() };
    }

    if (stored.savedAt && Date.now() - stored.savedAt > ttlMs) {
      return { sessionId: null, visitorId: stored.visitorId || generateId() };
    }

    return {
      sessionId: stored.sessionId || null,
      visitorId: stored.visitorId || generateId()
    };
  }

  function persistSession(sessionId, visitorId, ttlMs) {
    writeStore(
      {
        sessionId: sessionId || null,
        visitorId: visitorId,
        savedAt: Date.now()
      },
      ttlMs
    );
  }

  function captureConversationToken() {
    return readCookie(CW_COOKIE);
  }

  function identifyUser(config, visitorId) {
    if (!window.$chatwoot || typeof window.$chatwoot.setUser !== 'function') return;

    var customer = config.customer;
    var identifier = customer && customer.id ? String(customer.id) : String(visitorId);
    var user = {};

    if (customer) {
      if (customer.name) user.name = customer.name;
      if (customer.email) user.email = customer.email;
      if (customer.phone) user.phone_number = customer.phone;
    }

    window.$chatwoot.setUser(identifier, user);
  }

  function hideBubble(config) {
    if (!config.hideMessageBubble) return;

    document.documentElement.classList.add('limechat-hide-bubble');

    if (window.$chatwoot && typeof window.$chatwoot.toggleBubbleVisibility === 'function') {
      window.$chatwoot.toggleBubbleVisibility('hide');
    }
  }

  function bindLaunchers() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-limechat-open]');
      if (!trigger) return;

      event.preventDefault();
      if (!window.$chatwoot || typeof window.$chatwoot.toggle !== 'function') return;
      window.$chatwoot.toggle('open');
    });
  }

  function runSdk(config, session) {
    if (!window.chatwootSDK || typeof window.chatwootSDK.run !== 'function') return;

    window.chatwootSettings = window.chatwootSettings || {};
    window.chatwootSettings.hideMessageBubble = !!config.hideMessageBubble;

    var runOptions = {
      websiteToken: config.websiteToken,
      baseUrl: config.baseUrl
    };

    if (session.sessionId) {
      runOptions.session_id = session.sessionId;
      runOptions.cw_conversation = session.sessionId;
    }

    window.chatwootSDK.run(runOptions);
  }

  function onReady(config, session, ttlMs) {
    identifyUser(config, session.visitorId);
    hideBubble(config);

    var token = captureConversationToken() || session.sessionId;
    persistSession(token, session.visitorId, ttlMs);

    window.setTimeout(function () {
      var later = captureConversationToken();
      if (later) persistSession(later, session.visitorId, ttlMs);
    }, 1500);
  }

  var config = getConfig();
  if (!config || !config.websiteToken) return;

  var ttlMs = config.sessionTtlMs || DEFAULT_TTL_MS;
  var session = getSession(ttlMs);

  if (config.customer && config.customer.id) {
    session.visitorId = String(config.customer.id);
  }

  persistSession(session.sessionId, session.visitorId, ttlMs);
  bindLaunchers();

  window.chatwootSettings = window.chatwootSettings || {};
  window.chatwootSettings.hideMessageBubble = !!config.hideMessageBubble;
  hideBubble(config);

  window.addEventListener('chatwoot:ready', function () {
    onReady(config, session, ttlMs);
  });

  var existing = document.querySelector('script[data-limechat-sdk]');
  if (existing) {
    if (window.chatwootSDK) runSdk(config, session);
    return;
  }

  var script = document.createElement('script');
  script.src = config.sdkSrc;
  script.defer = true;
  script.setAttribute('data-limechat-sdk', 'true');
  script.onload = function () {
    runSdk(config, session);
  };
  document.body.appendChild(script);
})();
